import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import TextInput from 'components/Inputs/TextInput'
import BusinessList from 'components/Lists/BusinessList'
import Select from 'components/Inputs/Select'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, FilterContainer, Row, SubTitle, InfoText } from './styles'
import { FaStar } from 'react-icons/fa'

export default function Businesses () {
  const [loading, setLoading] = useState (true)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [total, setTotal] = useState (0)
  const [query, setQuery] = useState ('')
  const [orderBy, setOrderBy] = useState (null)
  const [status, setStatus] = useState ({
    label: 'Ativos', value: 'active'
  })
  const [businesses, setBusinesses] = useState ([])
  const [avgBusinessesRating, setAvgBusinessesRating] = useState (0)
  const token = AuthService.getToken ()

  const selectStyles = { width: 450 }

  const statusOptions = [
    {label: 'Ativos', value: 'active'},
    {label: 'Pendentes', value: 'pending'},
    {label: 'Inativos', value: 'inactive'},
    {label: 'Arquivados', value: 'archived'}
  ]

  const orderOptions = [
    {label: 'Mais recentes', value: 'newest'},
    {label: 'Mais antigos', value: 'oldest'},
    {label: 'Melhor avaliados', value: 'best_rated'}
  ]

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getBusinesses (status, query, orderBy, 1)
  }, [status, orderBy, query])

  const getBusinesses = async (
    selectedStatus = status, nameQuery = query, order = orderBy, pageNumber = page
  ) => {
    if (lastPage && pageNumber > lastPage) return

    try {
      if (pageNumber === 1) setLoading (true)
      const filters = `page=${pageNumber}&name=${encodeURIComponent (nameQuery)}&status=${selectedStatus.value}&order=${order?.value}`

      const { data: businessesResponse } = await cutileiApi.get (`/businesses?${filters}`, requestConfig)
      const { data: avgRatingResponse } = await cutileiApi.get ('/businesses_ratings', requestConfig)
      const { data, meta } = businessesResponse
      const businessesData = pageNumber > 1 ? [...businesses, ...data] : data

      setBusinesses (businessesData)
      setAvgBusinessesRating (avgRatingResponse.average_rating)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
      setTotal (meta.total)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const handleUpdate = updatedBusiness => {
    if (updatedBusiness.status !== status.value) {
      setBusinesses (prevBusinesses => prevBusinesses.filter (
        business => business.id !== updatedBusiness.id
      ))
      setTotal (prevTotal => prevTotal - 1)
    } else {
      setBusinesses (prevBusinesses => prevBusinesses.map (
        business => business.id === updatedBusiness.id ? updatedBusiness : business
      ))
    }
  }

  return (
    <Container>
      <AdminNavbar/>
      <FilterContainer>
        <Select
          name='category'
          placeholder='Categoria...'
          value={status}
          options={statusOptions}
          onChange={(_, option) => setStatus (option)}
          containerStyles={selectStyles}
        />
        <Select
          name='orderBy'
          placeholder='Ordenar por...'
          value={orderBy}
          options={orderOptions}
          isClearable={true}
          onChange={(_, option) => setOrderBy (option)}
          containerStyles={selectStyles}
        />
        <TextInput
          value={query}
          placeholder='Pesquisar por nome'
          isClearable={true}
          onChange={e => setQuery (e.target.value)}
          onClear={() => setQuery ('')}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 30}}/> : (
        <>
          {status.value === 'active' && (
            <Row>
              <InfoText>Avaliação média dos salões:</InfoText>
              <FaStar size={15} color='#FFC100'/>
              <SubTitle>{avgBusinessesRating}</SubTitle>
            </Row>
          )}
          <BusinessList
            businesses={businesses}
            totalBusinesses={total}
            hasMore={!(lastPage && page > lastPage)}
            onScroll={getBusinesses}
            onUpdate={handleUpdate}
          />
        </>
      )}
    </Container>
  )
}
